import { mapParamToItem } from '../../manifest-mappers/conversion-utils';
import { StyleType, DataType } from '../../types/metadata/variants';
export function resolveDefaultValue(_ref) {
  let {
    metadata,
    params,
    isMobile = false,
    t
  } = _ref;
  const resolvedMetadata = resolveMetadata(metadata, t);
  const resolvedParams = Object.fromEntries(Object.entries(params).map(_ref2 => {
    let [key, value] = _ref2;
    return [key, {
      metadata: value.metadata ? resolveMetadata(value.metadata, t) : undefined
    }];
  }));
  const item = mapParamToItem({
    metadata: resolvedMetadata,
    params: resolvedParams,
    isMobile,
    validate: type => type in StyleType || type in DataType,
    createItem: (itemType, defaultValue) => {
      return isStyleType(itemType) ? {
        cssPropertyType: itemType,
        defaultValue
      } : {
        dataType: itemType,
        defaultValue
      };
    }
  });
  if (isStyleType(resolvedMetadata.type)) {
    const styleItem = item && 'cssPropertyType' in item ? item : undefined;
    return {
      type: resolvedMetadata.type,
      defaultValue: styleItem == null ? void 0 : styleItem.defaultValue
    };
  }
  if (isDataType(resolvedMetadata.type)) {
    const dataItem = item && 'dataType' in item ? item : undefined;
    return {
      type: resolvedMetadata.type,
      defaultValue: dataItem == null ? void 0 : dataItem.defaultValue
    };
  }
  throw new Error('Invalid item type received');
}
const resolveMetadata = (metadata, t) => typeof metadata === 'function' ? metadata({
  t
}) : metadata;
const isStyleType = type => type in StyleType;
const isDataType = type => type in DataType;
//# sourceMappingURL=resolve-default-values.js.map